import ImageViewer from './ImageViewer';
import tplImageViewerProductDetails from './templates/image_viewer_product_details.pug';

window.addEventListener('DOMContentLoaded', () => {

  // Image viewer: Product details image gallery
  const imageViewerEl = document.querySelector('[data-slider="product_details"]');
  if (imageViewerEl) {
    new ImageViewer(imageViewerEl, {
      templateFn: tplImageViewerProductDetails,
      templateData: {
        i18n: {
          btn_download_label: Settings.general.i18n.btn_download_label,
        },
      },
    });
  }
});
